<template>
  <div class="contatti">
    <common-hero
      :background="pageApiData.cover"
      class="no-scroll-down">
      <h1>{{ pageApiData.title }}</h1>
      <div
        class="contatti__datas"
        v-html="pageApiData.content"></div>
      <router-link
        :to="{ name: `${lang}-richiesta-contatti`, params: { lang } }"
        class="link-triangle-effect">
        {{ $t('testoLinkBottomCta') }}
      </router-link>
    </common-hero>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import CommonHero from '@/components/CommonHero'

export default {
  mixins: [ lang, dataLoad ],
  components: {
    CommonHero
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .contatti .common-hero h1{
    margin-top: 12rem;
  }

  .contatti .contatti__datas{

    display: flex;
    flex-direction: column;

    margin-top: 5rem;

    @media #{$xlarge_mq} {
      margin-top: 7rem;
      flex-direction: row;
    }

    ul, ol{
      @media #{$xlarge_mq} {
        margin-right: 10rem;
      }
      margin-bottom: 3rem;
    }

    li{
      @include size-18-pixel(#EFEFF1);
      line-height: 1.8;
      font-family: 'Roboto', sans-serif;
      font-weight: 300;
      color: #EFEFF1;
    }

    li strong{
      font-family: 'Roboto', sans-serif;
      font-weight: 700;
      color: #9b9b9b;
    }

    a{
      color: #EFEFF1;
      text-decoration: none;
    }
  }

  .richiestaInformazioni{
    font-size: 1.8rem;
    border: 0;
    background-color: #679196;
    color: #EFEFF1;
    border-radius: 35px;
    padding: 1.8rem 1rem 30rem 2.4rem;
    display: inline-block;
    width: 100%;
    cursor: pointer;
    margin-top: 4rem;
    margin-bottom: 4rem;
    font-weight: 300;

    @media #{$medium_mq} {
      width: 312px;
    }
    img{
      margin-left: 1rem;
      vertical-align: middle;
      top: -3px;
    }
  }

  .link-triangle-effect{
    @include link-triangle-effect(#EFEFF1);
    margin-bottom: 3rem;
    @media #{$large_mq} {
      margin-bottom: 0;
    }
  }

</style>
